
export function generateDeepLink(code: string): string {
  return `https://app.dev.csb-da.com/auth/${code}`;
}